/**
 * Check a page for js-youtube-video elements and load them trough the Youtube API
 *
 * @since 1.0.0
 */

/* global YT */

const youtubeVideos = document.querySelectorAll('.js-youtube-video')
const playButtons = document.querySelectorAll('.js-play-youtube-video')
const youtubePlayers = []

const YoutubeVideos = function () {
  if (youtubeVideos.length) {
    loadYoutubeApi()
  }
  if (playButtons.length) {
    [ ...playButtons ].forEach(el => {
      el.addEventListener('click', () => {
        let videoContainer = el.getAttribute('data-video-container')
        let iframeTarget = el.getAttribute('data-iframe-target')

        addContainerPlayingState(videoContainer)
        playVideo(iframeTarget)
      })
    })
  }
}

function loadYoutubeApi () {
  var tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  var firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

window.onYouTubeIframeAPIReady = function () {
  [ ...youtubeVideos ].forEach(el => {
    const { youtubeVideoId, iframeId } = el.dataset
    if (youtubeVideoId && iframeId) {
      youtubePlayers.push({
        iframeId: iframeId,
        containerID: el.id,
        player: createPlayer(iframeId, youtubeVideoId)
      })
    } else {
      console.error('YoutubeID or iframeId is not set')
    }
  })
}

function createPlayer (containerID, youtubeVideoId) {
  return new YT.Player(containerID, {
    height: '390',
    width: '640',
    videoId: youtubeVideoId,
    playerVars: {
      rel: 0,
      showinfo: 0,
      autohide: 1,
      playsinline: 1,
      html5: 1,
      modestbranding: 1
    },
    events: { onStateChange: onPlayerStateChange }
  })
}

function onPlayerStateChange (e) {
  // Test if player is finished
  if (e.data === 0) {
    e.target.a.offsetParent.classList.remove('c-video--playing')
  }
}

function addContainerPlayingState (container) {
  pauseAllPlayers()
  document.getElementById(container).classList.add('c-video--playing')
}

function pauseAllPlayers () {
  [ ...youtubePlayers ].forEach(el => {
    if (el.player.pauseVideo) {
      el.player.pauseVideo()
    }
  })
}

function playVideo (iframeID) {
  [ ...youtubePlayers ].forEach(el => {
    if (el.iframeID === iframeID) {
      el.player.playVideo()
    }
  })
}

export default YoutubeVideos



// WEBPACK FOOTER //
// ./src/js/modules/YoutubeVideos.js